import { servicesRequest } from '@pointOfSale/api';
import { Service } from '../models';
import * as MutationTypes from '../mutationTypes';

export const serviceListRequest = async ({ commit, getters: { serviceList } }, pointOfSaleGuid) => {
  if (!serviceList || serviceList.length === 0) {
    const response = await servicesRequest(pointOfSaleGuid);
    const serviceListRes = Service.toInstanceList(response.data);
    commit(MutationTypes.SERVICE_LIST_SUCCESS, serviceListRes);
  }
  return serviceList;
};
